// extracted by mini-css-extract-plugin
export var cursor = "cursor-module--cursor--b19d8";
export var dark = "cursor-module--dark--ee964";